module.exports = __webpack_public_path__ + "static/img/yis.e532fa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yis.png
// module id = +CO6
// module chunks = 0